import { FC } from 'react'
import { TypeFiltersByKeyOnce } from '@features/Restaurant/RestaurantFilters/model/types'
import { useAppDispatch, useAppSelector } from '@app/model/store/client'
import { BtnFilterTag } from '@shared/ui/Form/Single/Filters/DefaultTag'
import { BtnFilterAfishaTag } from '@shared/ui/Form/Single/Filters/AfishaTag'
import { setCheckedFilterItemAsync } from '@features/Restaurant/RestaurantFilters/model/thunks'
import { EGG } from '@shared/api/analytics'
import { getFilterSelected } from '@features/Restaurant/RestaurantFilters/helpers'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

interface Props {
  typeFilter: TypeFiltersByKeyOnce
  handleChange: () => void
  className?: string
}

const title = {
  afishaSelected: 'Выбор Афиши',
  hasBooking: 'Онлайн бронь',
  openNow: 'Открыто сейчас',
  delivery: 'Доставка',
}

const titleMobile = {
  ...title,
  hasBooking: 'Бронь',
}

const FilterOnceTemplate: FC<Props> = ({ typeFilter, handleChange, className = '' }) => {
  const dispatch = useAppDispatch()
  const stateFilters = useAppSelector((store) => store.features.restaurant_filters)
  const { checked } = stateFilters.filters[typeFilter]
  const { isMobile } = useClientResponsive()

  const changeChecked = async () => {
    EGG.common.filter_use_click({
      filter_apply_type: typeFilter,
      filters_apply: getFilterSelected(),
      filter_apply_value: String(!checked),
    })
    const result = await dispatch(
      setCheckedFilterItemAsync({
        filterType: typeFilter,
        checked: !checked,
      }),
    )
    const status = setCheckedFilterItemAsync.fulfilled.match(result) ? result.payload : undefined
    if (status === 'applied') handleChange()
  }

  const Tag = typeFilter === 'afishaSelected' ? BtnFilterAfishaTag : BtnFilterTag

  return (
    <BlockBoundary>
      <Tag onClick={changeChecked} active={checked} className={className}>
        {isMobile ? titleMobile[typeFilter] : title[typeFilter]}
      </Tag>
    </BlockBoundary>
  )
}

export default FilterOnceTemplate
